import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

const PREFIX = 'melitta_admin_';
const COOKIES_LIFE_IN_YEAS = 10;

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  constructor(private cookies: CookieService) {}

  get(name: string): string | null {
    const value = this.cookies.get(PREFIX + name);
    return value === 'undefined' ? null : value;
  }

  put(name: string, val: string, session?: boolean): void {
    this.remove(name);
    const options: any = {
      path: '/',
    };
    if (!session) {
      options.expires = new Date(`${+new Date().getFullYear() + COOKIES_LIFE_IN_YEAS}`);
    }
    this.cookies.set(PREFIX + name, val, options);
  }

  remove(name: string): void {
    this.cookies.delete(PREFIX + name, '/');
  }
}
